/**
 * Query keys for the campaign-service reads. Read-only domain, so there is no
 * invalidation surface yet; the keys exist so two hooks reading the same
 * endpoint share one cache entry rather than firing twice.
 */
export const campaignsKeys = {
  all: ['campaigns'],
  /** The whole discount-campaign set the Promo Codes page pages client-side. */
  promoCodes: () => ['campaigns', 'promo-codes'],
  promoCode: (campaignId) => ['campaigns', 'promo-code', campaignId],
  promoCodeReport: (campaignId) => ['campaigns', 'promo-code', campaignId, 'report'],
  officeDiscountHistory: (officeId) => ['campaigns', 'office', officeId, 'discounts'],
  professionalCampaigns: (professionalId) => ['campaigns', 'professional', professionalId],
};
